// CODE FOR THE COMPARISON CARD BUTTONS
// Attach event listeners to all your styled buttons
document.querySelectorAll('.ajax-add-to-cart').forEach(button => {
  button.addEventListener('click', () => {
    const variantId = button.dataset.variant;

    if (!variantId) {
      console.error('No variant ID found on clicked button.');
      return;
    }

    // POST to Shopify's cart API
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    })
      .then(res => res.json())
      .then(() => {
        // Redirect to cart page after adding
        window.location.href = '/cart';
      })
      .catch(err => {
        console.error('Error adding to cart:', err);
      });
  });
});



document.addEventListener("DOMContentLoaded", () => {
  const productDataEl = document.querySelector(
    'script[type="application/json"][data-section-type="static-product"]'
  );

  if (!productDataEl) {
    console.error("Product JSON not found.");
    return;
  }

  const json = JSON.parse(productDataEl.textContent);
  const product = json.product;

  function formatMoney(cents) {
    return `$${(cents / 100).toFixed(2)}`;
  }

  document.querySelectorAll(".price[data-variant-id]").forEach(el => {
    const variantId = el.getAttribute("data-variant-id");
    const variant = product.variants.find(v => String(v.id) === variantId);

    if (variant) {
      el.textContent = formatMoney(variant.price);
    } else {
      el.textContent = "Unavailable";
    }
  });
});

// END OF THE CODE FOR THE COMPARISON CARD BUTTONS